'use strict';

angular.module('mobile-apps').factory('JiraApi', ['$resource',
    function($resource) {
        return $resource('/v1/jira/:mobileAppId', {
            mobileAppId: '@mobileAppId'
        }, {
            configure: {
                method: 'POST',
                url : '/v1/jira/:mobileAppId/configure',
                isArray: false,
                cache : false
            },
            getConfiguration: {
                method: 'GET',
                url : '/v1/jira/:mobileAppId/configuration',
                isArray: false,
                cache : false
            },
            addIssue: {
                method: 'POST',
                url : '/v1/jira/:mobileAppId/issues/add',
                isArray: false,
                cache : false
            },
			editIssue: {
				method: 'POST',
				url : '/v1/jira/:mobileAppId/issues/edit',
				isArray: false,
				cache : false
			},
            projects: {
                method: 'POST',
                url : '/v1/jira/projects',
                isArray: true,
                cache: false
            },
            issueTypes: {
                method: 'POST',
                url : '/v1/jira/issuetypes',
                isArray: true,
                cache: false
            },
			users: {
            	method: 'POST',
				url: '/v1/projects/:mobileAppId/jira/users',
				isArray: true,
				cache: false
			}
        });
    }
]);
